<template>
  <div class="school">
    <div class="school-wrapper">
      <!-- 建筑景观学院 -->
      <div class="section">
        <div class="title">
          <div class="school-icon"><img src="/Application/Home/Resource/static/images/mobile/space-icon.png" alt=""></div>
          <div class="title-content">SPACE<span>建筑景观学院</span></div>
        </div>
        <ul class="major-list">
          <li class="major-item">建筑<span>/ Architecture</span></li>
          <li class="major-item">景观<span>/ Landscape Architecture</span></li>
          <li class="major-item">城市设计<span>/ Urban Design</span></li>
          <li class="major-item">城市规划<span>/ Urban Planning</span></li>
          <li class="major-item">室内设计<span>/ Interior Architecture</span></li>
        </ul>
        <div class="section-swiper" id="architecture">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in architectureClass">
              <router-link class="school-card" :to="{name: item.urlName, params: {id: item.id}}">
                <div class="cover lazy-load"><img :src="item.thumb" alt=""></div>
                <div class="info">{{item.title}}</div>
              </router-link>
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination-one"></div>
        </div>
      </div>
      <!-- 人机交互学院 -->
      <div class="section">
        <div class="title">
          <div class="school-icon"><img src="/Application/Home/Resource/static/images/mobile/hci-icon.png" alt=""></div>
          <div class="title-content">HCI<span>人机交互学院</span></div>
        </div>
        <ul class="major-list">
          <li class="major-item">人机交互<span>/ Human Computer Interaction</span></li>
          <li class="major-item">服务设计<span>/ Service Design</span></li>
          <li class="major-item">用户体验设计<span>/ User Experience Design</span></li>
          <li class="major-item">交互设计<span>/ Interaction Design</span></li>
          <li class="major-item">新媒体艺术<span>/ New Media Art Design</span></li>
        </ul>
        <div class="section-swiper" id="computer">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in hciClass">
              <router-link class="school-card" :to="{name: item.urlName, params: {id: item.id}}">
                <div class="cover lazy-load"><img :src="item.thumb" alt=""></div>
                <div class="info">{{item.title}}</div>
              </router-link>
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination-two"></div>
        </div>
      </div>
      <!-- 艺术设计学院 -->
      <div class="section">
        <div class="title">
          <div class="school-icon"><img src="/Application/Home/Resource/static/images/mobile/art-icon.png" alt=""></div>
          <div class="title-content">ART<span>艺术设计学院</span></div>
        </div>
        <ul class="major-list">
          <li class="major-item">视觉传达<span>/ Visual Communication</span></li>
          <li class="major-item">工业设计<span>/ Industrial Design</span></li>
          <li class="major-item">艺术管理<span>/ Art Administration</span></li>
        </ul>
        <div class="section-swiper" id="art">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in artClass">
              <router-link class="school-card" :to="{name: item.urlName, params: {id: item.id}}">
                <div class="cover lazy-load"><img :src="item.thumb" alt=""></div>
                <div class="info">{{item.title}}</div>
              </router-link>
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination-three"></div>
        </div>
      </div>
    </div>
    <div class="modules-box">
      <router-link to="/course" class="modules-item workshop">
        <h4>小组课</h4>
        <span>丰富技能库</span>
      </router-link>
      <router-link to="/course" class="modules-item studio">
        <h4>设计室</h4>
        <span>做出好作品</span>
      </router-link>
      <router-link to="/lecturer" class="modules-item lecturer">
        <h4>师资</h4>
        <span>200+海外名校讲师</span>
      </router-link>
    </div>
    <Footer></Footer>
  </div>
</template>

<style lang="less" scpoed>
  .school-wrapper{
    padding: 24px 0 0;
    .section{
      margin-bottom: 8px;
      &:last-child{
        margin-bottom: 0;
      }
      .title{
        display: flex;
        align-items: flex-start;
        padding: 0 20px;
        .school-icon{
          flex-shrink: 0;
          width: 32px;
          height: 32px;
          img{
            width: 100%;
          }
        }
        .title-content{
          position: relative;
          margin-left: 8px;
          font-size: 22px;
          line-height: 22px;
          font-weight: bold;
          color: rgba(77, 162, 199, 0.2);
          transform: translateY(-3px);
          span{
            position: absolute;
            left: 0;
            top: 16px;
            font-size: 18px;
            line-height: 18px;
            color: #333;
            white-space: nowrap;
          }
        }
      }
      .major-list{
        margin-top: 16px;
        font-size: 13px;
        line-height: 13px;
        padding: 0 20px;
        .major-item{
          display: flex;
          margin-bottom: 12px;
          color: #333;
          &:last-child{
            margin-bottom: 0;
          }
          span{
            margin-left: 8px;
            color: #666;
          }
        }
      }
      .section-swiper{
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 2.42rem;
        .swiper-slide{
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 20px;
          .school-card{
            position: relative;
            width: 100%;
            height: 1.98rem;
            box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.2);
            border-radius: 8px;
            overflow: hidden;
            .cover{
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                width: 100%;
              }
            }
            .info{
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 38px;
              padding: 0 12px;
              font-size: 14px;
              line-height: 38px;
              color: #FFF;
              background: rgba(0,0,0,.6);
            }
          }
        }
      }
    }
  }
  .modules-box{
    padding: 12px 20px;
    .modules-item{
      width: 100%;
      height: .78rem;
      padding: 0 12px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      margin-bottom: 12px;
      border-radius: 8px;
      color: #FFF;
      &.workshop{
        background: url('/Application/Home/Resource/static/images/mobile/seminar-card.png') no-repeat center center;
        background-size: cover;
      }
      &.studio{
        background: url('/Application/Home/Resource/static/images/mobile/studio-card.png') no-repeat center center;
        background-size: cover;
      }
      &.lecturer{
        background: url('/Application/Home/Resource/static/images/mobile/teachers-card.png') no-repeat center center;
        background-size: cover;
      }
      h4{
        font-size: 18px;
        line-height: 18px;
        font-weight: 600;
        margin-bottom: 8px;
      }
      span{
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
</style>

<style lang="less">
  .section-swiper .swiper-pagination {
    top: unset;
    bottom: 24px;
    right: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    transform: translateY(0);
    .swiper-dot{
      display: block;
      width: 4px;
      height: 4px;
      background-color: #CCC;
      margin-top: 4px;
      cursor: pointer;
      outline: none;
      border-radius: 50%;
      &:first-child{
        margin-top: 0;
      }
    }
    .swiper-dot-active{
      background-color: @cano;
    }
  }
</style>

<script>
  import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
  import Footer from '@/components/Common/footer.vue'
  import 'swiper/swiper-bundle.css'
  export default {
    data() {
      return {
        // 课程数据
        architectureClass: [],
        hciClass: [],
        artClass: [],
        swiperElement: [
          {swiper: null, el: '#architecture', nav: '.swiper-pagination-one'},
          {swiper: null, el: '#computer',nav: '.swiper-pagination-two'},
          {swiper: null, el: '#art',nav: '.swiper-pagination-three'}
        ]
      }
    },
    components: {
      Footer
    },
    created() {
      this.$root.post('/College/get_all_college_course').then(data => {
        // 为数据匹配对应的url
        Object.keys(data).forEach((key) => {
          if (data[key]) {
            data[key].forEach(item => {
              switch (item.type) {
                case '1': item.urlName = 'workshopDetail'; break;
                case '2': item.urlName = 'studioDetail'; break;
                case '3': item.urlName = 'articleDetail'; break;
              }
            })
          }
        })
        this.architectureClass = data.architecture_class || [];
        this.hciClass = data.hci_class || [];
        this.artClass = data.art_class || [];
        // 数据加载完成后启动轮播
        this.$nextTick(() => {
          Swiper.use([Navigation, Pagination, Autoplay]);
          this.swiperElement.forEach((item) => {
            item.swiper = new Swiper(item.el, {
              direction: 'vertical',
              speed: 400,
              autoplay: {
                delay: 4000,
              },
              pagination: {
                el: item.nav,
                bulletClass: 'swiper-dot',
                bulletActiveClass: 'swiper-dot-active',
                clickable: true,
              }
            });
          })
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/School/index.vue